module.exports = __webpack_public_path__ + "static/img/i10.cdbe00b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i10.png
// module id = C5dW
// module chunks = 0